import React, {useMemo, useState} from "react";
import {CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {Button, Form, notification, Modal} from "antd";
import './stripe-form.scss'
import {addCardStripeOfCustomer} from "../../../../actions/paymentActions";
import {logout} from "../../../../actions/authActions";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

const useOptions = () => {
  const options = useMemo(
    () => ({
      style: {
        base: {
          color: "#000",
          letterSpacing: "0.025em",
          fontFamily: "Montserrat",
          "::placeholder": {
            color: "#dfdfdf",
            fontSize: '14px'
          }
        },
        invalid: {
          color: "#ca3e47"
        }

      }
    }),
    []
  );

  return options;
};

const SplitFormStripe = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const options = useOptions();
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null);

  const alertMessage = (type = 'error', message = '') => {
    notification[type]({
      description: message,
      className: 'ps-alert-message'
    });
  };

  const saveCreditCard = async (e) => {
    e.preventDefault()
    setLoading(true)
    if (!stripe || !elements) {
      return;
    }
    const cardNumberElement = elements.getElement(CardNumberElement)
    const cardExpiryElement = elements.getElement(CardExpiryElement)
    const cardCvcElement = elements.getElement(CardCvcElement)

    try {
      const token_card = await stripe.createToken(cardNumberElement)
      if (token_card.error) {
        setError(token_card.error);
        setLoading(false)
        return;
      }
      console.log('token_card', token_card);
      if (token_card && token_card.token) {
        addCardStripeOfCustomer({token: token_card.token.id}).then((res) => {
          if (props.isRedirect) {
            props.history.goBack();
            return;
          }
          props.getCards && props.getCards();
          setLoading(false)
          props.form.resetFields()
          alertMessage('success', res.data.message)
          cardNumberElement.clear()
          cardExpiryElement.clear()
          cardCvcElement.clear()
        })
          .catch((err) => {
            const responseData = err && err.response ? err.response.data : null;
            console.log(responseData);
            setLoading(false)

            const errorResponse = responseData || {};
            const errorMessage = errorResponse.message || 'Something went wrong. Please try again.';
            const isBlocked = errorResponse.statusCode === 403 || errorResponse.is_blocked;

            if(!isBlocked) {
              return alertMessage('error', errorMessage)
            }
            const redirectToLogin = () => {
              if (typeof props.logout === 'function') {
                props.logout();
              }
              props.history.replace('/login');
            };

            Modal.error({
              className: 'ps-error-modal',
              title: 'Unable to add this card',
              icon: null,
              centered: true,
              okText: 'Go to login',
              closable: false,
              maskClosable: false,
              keyboard: false,
              content: errorMessage,
              onOk: () => {
                if (isBlocked) {
                  redirectToLogin();
                }
              }
            });
          });
      }
    } catch (e) {
      setLoading(false)
      alertMessage('error', e.message)
    }
  }

  const ErrorMessage = ({children}) => (
    <div className="ErrorMessage" role="alert">
      <svg width="13" height="13" viewBox="0 0 20 13">
        <path
          fill="#FFF"
          d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"
        />
        <path
          fill="#6772e5"
          d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"
        />
      </svg>
      {children}
    </div>
  );

  return (
    <div className='form-stripe-create'>
      <p className="header-form">
        Add Card
      </p>
      <Form
        layout="vertical"
        name="add-payment-method"
        initialValues={{
          'payment_method': 1,
        }}

        onSubmit={saveCreditCard}
      >
        <div className="info-card">
          <label>
            Card Number
            <CardNumberElement
              options={options}
              onChange={(event) => setError(event.error)}
            />
          </label>
          <div className='info-more'>
            <label>
              Exp. Date
              <CardExpiryElement
                options={options}
                onChange={(event) => setError(event.error)}
              />
            </label>
            <label>
              CVC
              <CardCvcElement
                options={options}
                onChange={(event) => setError(event.error)}
              />
            </label>
          </div>
        </div>

        <Form.Item style={{margin: '0 auto', textAlign: 'center'}} className="w-100">
          {error && <ErrorMessage>{error.message}</ErrorMessage>}
          <Button loading={loading} htmlType="submit" className="w-50" id="btn-add-payment-method">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default withRouter(connect(null, {logout})(Form.create()(SplitFormStripe)));



// WEBPACK FOOTER //
// ./src/components/Settings/Dashboard/Include/SplitFormStripe.jsx